<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screen.screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" persistent>
          <v-card>
            <v-card-title>
              <span class="headline">{{
                $formTitle("要配慮者施設状況", screen.readOnly, false)
              }}</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="isPassedValidation">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="8" lg="6">
                      <v-text-field
                        label="施設名"
                        :placeholder="config.PLACEHOLDER_SP"
                        disabled
                        :value="editedItem.fa_name"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="8" lg="6">
                      <v-text-field
                        label="施設名（カナ）"
                        :placeholder="config.PLACEHOLDER_SP"
                        disabled
                        :value="editedItem.fa_name_kana"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-select
                        :items="$facility.evacuationStatuses"
                        v-model="editedItem.eva_status"
                        label="避難状況"
                        :placeholder="config.PLACEHOLDER_SELECT"
                        v-bind="formControlProps()"
                        :rules="[$validation.rules.required]"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col class="caption search-item-caption">
                      避難対象者数
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        v-model="editedItem.evacuee_vala"
                        label="教員/職員"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        suffix="人"
                        v-bind="formControlProps(4)"
                        :rules="[$validation.rules.numeric]"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        v-model="editedItem.evacuee_valb"
                        label="患者/児童/生徒/入所者"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        suffix="人"
                        v-bind="formControlProps(4)"
                        :rules="[$validation.rules.numeric]"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-textarea
                        v-model="editedItem.free_input"
                        label="備考"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        v-bind="formControlProps(500)"
                      >
                      </v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mx-2"
                color="primary"
                @click="save"
                :disabled="!isPassedValidation"
              >
                更新
              </v-btn>
              <v-btn class="mx-2" color="primary" @click="close">
                キャンセル
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0;">
          要配慮者施設状況は下の表を参照してください。条件を指定することで一覧から絞り込むことができます。
        </p>
        <v-row>
          <v-col cols="6" md="3">
            <v-select
              v-model="searchItem.municipality"
              :items="municipalities"
              label="市町村"
              :placeholder="config.PLACEHOLDER_SELECT"
              @change="changeMunicipality"
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <v-select
              v-model="searchItem.area"
              :items="$facility.areasForSearch(areas)"
              label="地域（地区）"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="3">
            <v-select
              v-model="searchItem.facilityType"
              :items="[...$facility.facilityTypes]"
              label="施設種別"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
              :disabled="!hasItems(searchItem, items)"
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <v-select
              v-model="searchItem.shelterExist"
              :items="[...$facility.shelterExists]"
              label="シェルター有無"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
              :disabled="!hasItems(searchItem, items)"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0" cols="6" md="3">
            <v-select
              v-model="searchItem.evacuationStatus"
              :items="[...$facility.evacuationStatuses]"
              label="避難状況"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
              :disabled="!hasItems(searchItem, items)"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <p>
              部分一致で検索することができます。<br />
              検索は施設名、施設名（カナ）、施設住所、施設管理者／責任者、備考の項目が対象です。<br />
              スペースを挟み、複数の語句で検索することはできません。
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="searchItem.freeText"
              label="フリーテキスト"
              placeholder="施設名、施設名（カナ）、施設住所、施設管理者/責任者、備考から検索"
              clearable
              append-icon="mdi-magnify"
              outlined
              :disabled="!hasItems(searchItem, items)"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-divider class="mb-1"></v-divider>
      </v-container>
      <top-operation-data-table
        :headers="headers"
        :items="items"
        locale="ja-jp"
        item-key="fa_id"
        :sort-by="sort.by"
        :sort-desc="sort.desc"
        v-if="hasItems(searchItem, items)"
        must-sort
        dispMode="nowrap"
        ref="resetPagination"
      >
        <template v-slot:[`item.disp_no`]="{ item }">
          {{ $facility.facilityName(item) }}
        </template>
        <template v-slot:[`item.fa_name_kana`]="{ item }">
          {{ $facility.facilityNameKana(item) }}
        </template>
        <template v-slot:[`item.evacuee_vala`]="{ item }">
          {{ item.evacuee_vala | format }}
        </template>
        <template v-slot:[`item.evacuee_valb`]="{ item }">
          {{ item.evacuee_valb | format }}
        </template>
        <template v-slot:[`item.vulner_ppl_fa_type`]="{ item }">
          {{ $facility.facilityTypeName(item) }}
        </template>
        <template v-slot:[`item.shelter_exist`]="{ item }">
          {{ $facility.shelterExistName(item) }}
        </template>
        <template v-slot:[`item.eva_status`]="{ item }">
          {{ $facility.evacuationStatusName(item) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn small class="mx-2" color="primary" @click="viewItem(item)">
            参照
          </v-btn>
          <v-btn
            small
            class="mx-2"
            color="primary"
            @click="editItem(item)"
            v-if="!screen.readOnly"
            :disabled="!hasUpdateAuthorityByItem(item)"
          >
            編集
          </v-btn>
        </template>
      </top-operation-data-table>
    </v-sheet>
    <confirm-dialog ref="confirmDelete" />
    <vulner-people-facility-detail
      ref="facility"
      v-if="hasItems(searchItem, items)"
    />
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import ConfirmDialog from "@/components/ConfirmDialog";
import VulnerPeopleFacilityDetail from "@/components/facility/VulnerPeopleFacilityDetail";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import config from "@/js/const";
import { ScreenId } from "@/js/value-objects/screen-id";
import { AllAreaTranslator } from "@/js/translators/allAreaTranslator";
import messageUtils from "@/mixins/message-utils";
import { VulFacilityStatusTranslator } from "@/js/translators/vulFacilityStatusTranslator";
import Validation from "@/plugins/validation";
import Disaster from "@/plugins/disaster";
import Facility from "@/plugins/facility";
Vue.use(Validation, Disaster, Facility);
const vulFacilityStatusRepository = RepositoryFactory.get("vulFacilityStatus");
const SEARCH_ITEM = Object.freeze({
  municipality: null,
  area: null,
  facilityType: null,
  shelterExist: null,
  evacuationStatus: "",
  freeText: ""
});
const FACILITY_STATUS_ITEM = Object.freeze({
  fa_id: null,
  fa_name: "",
  municip_code: "",
  area_code: "",
  eva_status: null,
  evacuee_vala: 0,
  evacuee_valb: 0,
  free_input: ""
});
export default {
  mixins: [messageUtils],

  components: {
    ConfirmDialog,
    VulnerPeopleFacilityDetail,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },

  data: () => ({
    config: config,
    overlay: false,
    dialog: false,
    screen: null,
    items: [],
    editedIndex: -1,
    searchItem: cloneDeep(SEARCH_ITEM),
    editedItem: cloneDeep(FACILITY_STATUS_ITEM),
    defaultItem: cloneDeep(FACILITY_STATUS_ITEM),
    municipalities: [],
    areas: [],
    errors: null,
    isPassedValidation: false
  }),

  mounted() {
    this.pageTitle(this.screen.screenTitle);
  },

  computed: {
    headers() {
      return [
        {
          text: "フリーテキスト",
          align: " d-none",
          value: "fa_id",
          filter: this.freeTextFilter
        },
        {
          text: "地域（地区）",
          align: " d-none",
          value: "area_code",
          filter: this.areaFilter
        },
        {
          text: "施設名",
          align: "start",
          value: "disp_no"
        },
        {
          text: "施設名（カナ）",
          value: "fa_name_kana"
        },
        {
          text: "避難対象者数（教員/職員）",
          value: "evacuee_vala"
        },
        {
          text: "避難対象者数（患者/児童/生徒/入所者）",
          value: "evacuee_valb"
        },
        {
          text: "施設種別",
          value: "vulner_ppl_fa_type",
          filter: this.facilityTypeFilter
        },
        {
          text: "シェルター有無",
          value: "shelter_exist",
          filter: this.shelterExistFilter
        },
        {
          text: "避難状況",
          value: "eva_status",
          filter: this.evacuationStatusFilter
        },
        {
          text: "操作",
          value: "actions",
          sortable: false,
          width: 180
        }
      ];
    },

    sort() {
      return {
        by: ["disp_no"],
        desc: [false]
      };
    },

    formControlProps: () => {
      return function(counter = null) {
        return this.$formControlProps(this.screen.readOnly, counter);
      };
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    $route: "initialize"
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize(isAfterSaved = false) {
      this.overlay = true;
      this.screen = this.$screenOperationAuthority(
        ScreenId.SF1505,
        ScreenId.SF1506
      );
      await this.$store
        .dispatch("allArea/loadAllArea")
        .then(() => {
          this.municipalities = this.$store.state.allArea.municipalities;
        })
        .catch(e => {
          this.handleError(e, this.screen.screenId, "aggregation-menu");
        });
      if (isAfterSaved) {
        await this.$store
          .dispatch("vulFacilityStatus/loadVulFacilityStatus", {
            screenId: this.screen.screenId,
            municipality: this.searchItem.municipality,
            disasterNo: this.$disaster.disaster_no
          })
          .then(() => {
            this.items = this.$store.state.vulFacilityStatus.data.results;
          })
          .catch(e => {
            this.handleError(e, this.screen.screenId, "aggregation-menu");
          });
      }
      this.overlay = false;
    },

    async changeMunicipality(municipality) {
      this.overlay = true;
      this.items = [];
      this.areas = AllAreaTranslator.toAreasByMunicipality(
        this.$store.state.allArea.areas,
        municipality
      );
      await this.$store
        .dispatch("vulFacilityStatus/loadVulFacilityStatus", {
          screenId: this.screen.screenId,
          municipality,
          disasterNo: this.$disaster.disaster_no
        })
        .then(() => {
          this.items = this.$store.state.vulFacilityStatus.data.results;
        })
        .catch(e => {
          this.handleGetError(e);
        });
      Object.assign(this.searchItem, { area: "" });
      this.overlay = false;
    },

    evacuationStatusFilter(value) {
      this.resetPage();
      if (!this.searchItem.evacuationStatus) {
        return true;
      }
      return value === this.searchItem.evacuationStatus;
    },

    facilityTypeFilter(value) {
      this.resetPage();
      if (!this.searchItem.facilityType) {
        return true;
      }
      return value === this.searchItem.facilityType;
    },

    shelterExistFilter(value) {
      this.resetPage();
      if (!this.searchItem.shelterExist) {
        return true;
      }
      return value === this.searchItem.shelterExist;
    },

    areaFilter(value) {
      this.resetPage();
      if (!this.searchItem.area) {
        return true;
      }
      return value === this.searchItem.area;
    },

    freeTextFilter(value) {
      const freeText = this.searchItem.freeText;
      if (freeText === "" || freeText === null) {
        return true;
      }
      const item = this.items.find(item => item.fa_id === value);
      if (item) {
        const hasFacilityName = item.fa_name.includes(freeText);
        if (hasFacilityName) {
          return true;
        }
        const hasFacilityNameKana = item.fa_name_kana.includes(freeText);
        if (hasFacilityNameKana) {
          return true;
        }
        const hasAddress = item.fa_address.includes(freeText);
        if (hasAddress) {
          return true;
        }
        const hasPerson = item.fa_respons_person.includes(freeText);
        if (hasPerson) {
          return true;
        }
        const hasRemarks =
          item.free_input && item.free_input.includes(freeText);
        if (hasRemarks) {
          return true;
        }
      }
    },
    /**検索時にページネーションをリセット
     * 初期表示ではテーブルが生成されていないためデータテーブルのメソッドが
     * 呼び出せない。生成されていることを確認してから呼びだす。
     */
    resetPage() {
      if (this.$refs.resetPagination) {
        this.$refs.resetPagination.resetPage();
      }
    },

    async viewItem(item) {
      await this.$refs.facility.open(item);
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.$refs.form.resetValidation();
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.$refs.form.validate() === false) {
        return;
      }
      const payload = await VulFacilityStatusTranslator.toPayload(
        this.editedItem
      );
      this.clearMessage();
      await vulFacilityStatusRepository
        .update(ScreenId.SF1507, payload)
        .then(response => {
          this.handleSuccess(response);
        })
        .catch(e => {
          this.handleUpdateError(e);
        });
      await this.close();
      await this.initialize(true);
    },

    hasMunicipality(searchItem) {
      return searchItem.municipality;
    },

    hasItems(searchItem, items) {
      if (!searchItem.municipality) {
        return false;
      }
      if (!items) {
        return false;
      }
      if (!Array.isArray(items)) {
        return false;
      }
      return items.length > 0;
    }
  }
};
</script>
